import React from "react";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { Row, Col } from "reactstrap";
import { languageService } from "../../../../Language/language.service";
import { maintenaceDetailstyle } from "../../styles/maintenanceDetailstyle";

function BridgeProps({ m1 }) {
  if (!m1.bridge) return null;
  const { observation, submittal, fdotId, associated, bridge, site } = m1.bridge;
  return (
    <Row>
      <Col md="12">
        <div style={themeService(maintenaceDetailstyle.fieldHeading)}> {languageService("Bridge")}: </div>

        <Col md="12">
          <Row>
            <Col md="12">
              <div>
                <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Submittal #")}: </div>
                <div style={themeService(maintenaceDetailstyle.fieldText)}>{submittal || ""}</div>
              </div>
            </Col>
            <Col md="12">
              <div>
                <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Observation #")}: </div>
                <div style={themeService(maintenaceDetailstyle.fieldText)}>{observation || ""}</div>
              </div>
            </Col>
            <Col md="12">
              <div>
                <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("FDOT ID #")}: </div>
                <div style={themeService(maintenaceDetailstyle.fieldText)}>{fdotId || ""}</div>
              </div>
            </Col>
            <Col md="12">
              <div>
                <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Associated Track")}: </div>
                <div style={themeService(maintenaceDetailstyle.fieldText)}>{associated || ""}</div>
              </div>
            </Col>
            <Col md="12">
              <div>
                <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Bridge #")}: </div>
                <div style={themeService(maintenaceDetailstyle.fieldText)}>{bridge || ""}</div>
              </div>
            </Col>
            <Col md="12">
              <div>
                <div style={themeService(maintenaceDetailstyle.fieldHeading)}>{languageService("Site #")}: </div>
                <div style={themeService(maintenaceDetailstyle.fieldText)}>{site || ""}</div>
              </div>
            </Col>
          </Row>
        </Col>
      </Col>
    </Row>
  );
}
export default BridgeProps;



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/DetailViews/BridgePropertiesView.jsx